import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  position: relative;
  margin: 25px 0 7px;
  font-size: 20px;
  font-weight: bold;
`;

const TopBoxDiv = ({ value, children }) => {
  return (
    <StyledDiv>
      <span>{value}</span>
      {children}
    </StyledDiv>
  );
};

export default TopBoxDiv;
